import { Component, OnInit } from "@angular/core";
import { Config } from "src/app/_config/config";
import { FormGroup, FormBuilder } from "@angular/forms";
import { DataService } from "../_service/data.service";
import { environment } from "src/environments/environment";
import { IDropdownSettings } from "ng-multiselect-dropdown";
import __ from "underscore";
import * as leadMedimColums from "./staticColumnsList.json";

declare const Highcharts: any;
declare const $: any;
declare const moment: any;

@Component({
  selector: "app-lead-type",
  templateUrl: "./lqs-lead.component.html",
  styleUrls: ["./lqs-lead.component.scss"],
})
export class LqsLeadComponent implements OnInit {
  // outletDropdownSettings: IDropdownSettings;
  dealerCodeDropdownSettings: IDropdownSettings;
  leadMediumDropdownSettings: IDropdownSettings;
  leadTypeDropdownSettings: IDropdownSettings;
  channelDropdownSettings: IDropdownSettings;
  outletTypeDropdownSettings: IDropdownSettings;
  public config: any = new Config();
  public dealercodeList: any = [];
  public leadmediumList: any = [];
  public leadtypeList: any = [];
  // public outletList: any = [];
  public filterForm: FormGroup;
  public start_date: any = moment().subtract("days", 30);
  public end_date: any = moment();
  public regionQualification: any = [];
  public outletQualification: any = [];
  public zoneQualification: any = [];
  public topModel: any = [];
  public imageUrl: string = environment.imageUrl;
  totalLeads: any = {
    total_leads: 0,
    qualified_sales_leads: 0,
    qualified_sales_leads_percentage: "0%",
    qualified_non_sales_leads: 0,
    junk_leads: 0,
    feedback_contactus_leads: 0,
  };
  dlrMediaData: any = [];
  qslData: any = [];
  loginData: any;
  dealercodeStatus: Boolean = false;
  leadmediumStatus: Boolean = false;
  leadtypeStatus: Boolean = false;
  outletStatus: Boolean = false;
  selectedDealerCode = [];
  selectedLeadMedium = [];
  selectedLeadType = [];
  // selectedOutlet = [];
  outletType = [];
  dealercode = [];
  leadmedium = [];
  leadtype = [];
  // outlet = [];
  apiReq = {
    dealercode: "",
    leadmedium: "",
    leadtype: "",
    // outlet: "",
    channel: "",
    outletType: "",
  };
  firstTimeRun: Boolean = true;
  columnName: any;
  public channelList: any = [];
  public outletTypeList: any = [];
  channelStatus: Boolean = false;
  selectedChannel = [];
  selectedOutletType = [];
  channelName: any = "";
  outletTypeName: any = "";
  bifurcationBy: any = "total";
  constructor(private fb: FormBuilder, private dataService: DataService) {
    this.filterForm = this.fb.group({
      dealercode: [""],
      leadmedium: [""],
      leadtype: [""],
      // outlet: [""],
      start_date: [this.start_date.format("YYYY-MM-DD")],
      end_date: [this.end_date.format("YYYY-MM-DD")],
      userType: [""],
    });
  }

  ngOnInit() {
    this.loginData = this.dataService.getCookies("loginData")
      ? JSON.parse(this.dataService.getCookies("loginData")).acl
      : JSON.parse(localStorage.getItem("loginData")).acl;

    // user level access modify this once user level clarified
    // if (this.loginData.userType === 6) {
    //   // TSM/RO
    //   this.parentStatus = true;
    //   this.getAllParent("aa");
    // } else if (this.loginData.userType === 8) {
    //   // Zonal
    //   this.regionStatus = true;
    //   this.dealercodeStatus = true;
    //   this.parentStatus = true;
    //   this.getAllRegion("aa");
    // } else if (this.loginData.userType === 1) {
    //   // Agency or HO
    //   this.regionStatus = true;
    //   this.dealercodeStatus = true;
    //   this.parentStatus = true;
    //   this.zoneStatus = true;
    //   this.channelStatus = true;
    //   this.getAllZone();
    // }
    if (this.loginData.userType === 9) {
      this.dealercodeStatus = true;
      // this.outletStatus = true;
      this.channelStatus = true;
      this.getAllChannel("''");
    } else if (this.loginData.userType === 10) {
      // Zonal manager
      this.dealercodeStatus = true;
      this.channelStatus = true;
    } else {
      this.dealercodeStatus = true;
      // this.outletStatus = true;
      this.channelStatus = true;
    }
    // call for every case now and implement hirerachy once confirmed
    // this.getAllDealerCode();
    this.getAllChannel("''");
    // this.getAllOutletType("''");
    this.getAllLeadMedium();
    this.getAllLeadType();
    this.filterForm.patchValue({
      userType: this.loginData.userType,
    });
   const today = moment();
const isFirstOfMonth = today.date() === 1;

const defaultStartDate = isFirstOfMonth
  ? today.clone().subtract(1, 'month').startOf('month').format('YYYY-MM-DD')
  : today.clone().startOf('month').format('YYYY-MM-DD');

const defaultEndDate = isFirstOfMonth
  ? today.clone().subtract(1, 'month').endOf('month').format('YYYY-MM-DD')
  : today.clone().subtract(1, 'day').format('YYYY-MM-DD');

this.filterForm.patchValue({
  start_date: defaultStartDate,
  end_date: defaultEndDate,
});

let options = {
  timePicker: false,
  startDate: moment(defaultStartDate, 'YYYY-MM-DD'),
  endDate: moment(defaultEndDate, 'YYYY-MM-DD'),
  maxDate: today.clone().subtract(1, 'day'),
  maxSpan: { days: 30 },
  locale: {
    format: "DD MMM YYYY",
  },
};

var self = this;
$('input[name="daterange_input"]').daterangepicker(options, callBack);
function callBack(start, end) {
  self.filterForm.controls["start_date"].setValue(
    moment(start).format("YYYY-MM-DD")
  );
  self.filterForm.controls["end_date"].setValue(
    moment(end).format("YYYY-MM-DD")
  );
}
    // this.outletSetting();
    this.dealercodeSetting(); // dealer code setting
    this.leadmediumSetting(); // lead medium setting
    this.leadtypeSetting(); // lead medium setting
    this.channelSetting();
    this.outletTypeSetting();
      this.advanceFilter();
  }
get isFilterApplied(): boolean {
  const today = moment();
  const isFirstOfMonth = today.date() === 1;

  const defaultStartDate = isFirstOfMonth
    ? today.clone().subtract(1, 'month').startOf('month').format('YYYY-MM-DD')
    : today.clone().startOf('month').format('YYYY-MM-DD');

  const defaultEndDate = isFirstOfMonth
    ? today.clone().subtract(1, 'month').endOf('month').format('YYYY-MM-DD')
    : today.clone().subtract(1, 'day').format('YYYY-MM-DD');

  const currentStart = this.filterForm.value.start_date;
  const currentEnd = this.filterForm.value.end_date;

  return (
    this.selectedChannel.length > 0 ||
    this.selectedLeadMedium.length > 0 ||
    this.selectedLeadType.length > 0 ||
    this.selectedDealerCode.length > 0 ||
    this.selectedOutletType.length > 0 ||
    currentStart !== defaultStartDate ||
    currentEnd !== defaultEndDate
  );
}

  // added dealer code settings
  dealercodeSetting() {
    this.dealerCodeDropdownSettings = {
      singleSelection: false,
      idField: "dealer",
      textField: "dealercode",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      allowSearchFilter: true,
      itemsShowLimit: 1,
    };
  }
  onDealercodeSelect(item: any) {
    this.selectedDealerCode.push(item.dealer);
    let data = "'" + this.selectedDealerCode.join("','") + "'";
    this.apiReq.dealercode = data;
    // if dependent fields then futher change accourdingly
  }
  onDealercodeAll(items: any) {
    this.selectedDealerCode = [];
    for (let i = 0; i < items.length; i++) {
      this.selectedDealerCode.push(items[i].dealer);
    }
    let data = "'" + this.selectedDealerCode.join("','") + "'";
    this.apiReq.dealercode = data;
    // if any dependent fields then handle fields accourdingly
  }
  onDealercodeDeSelect(item: any) {
    this.selectedDealerCode.splice(
      this.selectedDealerCode.indexOf(item.dealer),
      1
    );
    let data = "'" + this.selectedDealerCode.join("','") + "'";
    this.apiReq.dealercode = data;
    // if any dependent fields handle accourdingly
  }
  onDelercodeDeAll() {
    this.selectedDealerCode = [];
    this.apiReq.dealercode = "";
  }
  // lead medium
  leadmediumSetting() {
    this.leadMediumDropdownSettings = {
      singleSelection: false,
      idField: "leadmedium",
      textField: "lead_medium",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      allowSearchFilter: true,
      itemsShowLimit: 1,
    };
  }
  onLeadMediumSelect(item: any) {
    this.selectedLeadMedium.push(item.leadmedium);
    let data = "" + this.selectedLeadMedium.join(",") + "";
    this.apiReq.leadmedium = data;
  }
  onLeadMediumAll(items: any) {
    this.selectedLeadMedium = [];
    for (let i = 0; i < items.length; i++) {
      this.selectedLeadMedium.push(items[i].leadmedium);
    }
    let data = "" + this.selectedLeadMedium.join(",") + "";
    this.apiReq.leadmedium = data;
    // if any dependent fields then handle fields accourdingly
  }
  onLeadMediumDeSelect(item: any) {
    this.selectedLeadMedium.splice(
      this.selectedLeadMedium.indexOf(item.leadmedium),
      1
    );
    let data = "" + this.selectedLeadMedium.join(",") + "";
    this.apiReq.leadmedium = data;
  }
  onLeadMediumDeAll() {
    this.selectedLeadMedium = [];
    this.apiReq.leadmedium = "";
  }

  // lead type
  leadtypeSetting() {
    this.leadTypeDropdownSettings = {
      singleSelection: false,
      idField: "leadtype",
      textField: "leadtype",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      allowSearchFilter: true,
      itemsShowLimit: 1,
    };
  }
  onLeadTypeSelect(item: any) {
    this.selectedLeadType.push(item.leadtype);
    let data = "'" + this.selectedLeadType.join("','") + "'";
    this.apiReq.leadtype = data;
  }
  onLeadTypeAll(items: any) {
    this.selectedLeadType = [];
    for (let i = 0; i < items.length; i++) {
      this.selectedLeadType.push(items[i].leadtype);
    }
    let data = "'" + this.selectedLeadType.join("','") + "'";
    this.apiReq.leadtype = data;
    // if any dependent fields then handle fields accourdingly
  }
  onLeadTypeDeSelect(item: any) {
    this.selectedLeadType.splice(
      this.selectedLeadType.indexOf(item.leadtype),
      1
    );
    let data = "'" + this.selectedLeadType.join("','") + "'";
    this.apiReq.leadtype = data;
  }
  onLeadTypeDeAll() {
    this.selectedLeadType = [];
    this.apiReq.leadtype = "";
  }
  // outletSetting() {
  //   this.outletDropdownSettings = {
  //     singleSelection: false,
  //     idField: "webform_id",
  //     textField: "outlet",
  //     selectAllText: "Select All",
  //     unSelectAllText: "UnSelect All",
  //     itemsShowLimit: 1,
  //     allowSearchFilter: true,
  //   };
  // }

  // onOutletSelect(item: any) {
  //   this.selectedOutlet.push(item.webform_id);
  //   let data = "'" + this.selectedOutlet.join("','") + "'";
  //   this.apiReq.outlet = data;
  //   this.advanceFilter();
  // }
  // onOutletAll(items: any) {
  //   this.selectedOutlet = [];
  //   for (let i = 0; i < items.length; i++) {
  //     this.selectedOutlet.push(items[i].webform_id);
  //   }
  //   let data = "'" + this.selectedOutlet.join("','") + "'";
  //   this.apiReq.outlet = data;
  //   this.advanceFilter();
  // }

  // onOutletDeSelect(item: any) {
  //   this.selectedOutlet.splice(this.selectedOutlet.indexOf(item.webform_id), 1);
  //   let data = "'" + this.selectedOutlet.join("','") + "'";
  //   this.apiReq.outlet = data;

  //   this.advanceFilter();
  // }

  // onOutletDeAll() {
  //   this.selectedOutlet = [];
  //   this.apiReq.outlet = "";
  //   this.advanceFilter();
  // }

  channelSetting() {
    this.channelDropdownSettings = {
      singleSelection: false,
      idField: "channel",
      textField: "channel",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
  }
  onChannelSelect(item: any) {
    this.selectedChannel.push(item.channel);
    let data = "'" + this.selectedChannel.join("','") + "'";
    this.outletType = [];
    this.dealercode = [];
    this.selectedOutletType = [];
    this.selectedDealerCode = [];
    this.apiReq.dealercode = "";
    this.apiReq.outletType = "";
    this.apiReq.channel = data;
    this.channelName = data;
    this.getAllOutletType(data);
    // this.outlet = [];
  }
  onChannelAll(items: any) {
    this.selectedChannel = [];
    this.outletType = [];
    this.dealercode = [];
    this.selectedOutletType = [];
    this.selectedDealerCode = [];
    this.apiReq.dealercode = "";
    this.apiReq.outletType = "";
    for (let i = 0; i < items.length; i++) {
      this.selectedChannel.push(items[i].channel);
    }
    let data = "'" + this.selectedChannel.join("','") + "'";
    // this.outlet = [];
    this.apiReq.channel = data;
    this.channelName = data;
    this.getAllOutletType(data);
  }

  onChannelDeSelect(item: any) {
    this.selectedChannel.splice(this.selectedChannel.indexOf(item.channel), 1);
    let data = "'" + this.selectedChannel.join("','") + "'";
    this.apiReq.channel = data;
    this.outletType = [];
    this.dealercode = [];
    this.selectedOutletType = [];
    this.selectedDealerCode = [];
    this.apiReq.dealercode = "";
    this.apiReq.outletType = "";
    // this.outlet = [];
    this.channelName = data;
    this.getAllOutletType(data);
  }

  onChannelDeAll() {
    this.outletType = [];
    this.dealercode = [];
    this.selectedOutletType = [];
    this.selectedDealerCode = [];
    this.apiReq.dealercode = "";
    this.apiReq.outletType = "";
    this.selectedChannel = [];
    // this.outlet = [];
    this.apiReq.channel = "";
    this.channelName = "";
    this.getAllOutletType("''");
  }

  outletTypeSetting() {
    this.outletTypeDropdownSettings = {
      singleSelection: false,
      idField: "outlettype",
      textField: "outlettype",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
  }
  onOutletTypeSelect(item: any) {
    this.selectedOutletType.push(item.outlettype);
    let data = "'" + this.selectedOutletType.join("','") + "'";
    this.dealercode = [];
    this.selectedDealerCode = [];
    this.apiReq.dealercode = "";
    this.apiReq.outletType = data;
    this.outletTypeName = data;
    this.getAllDealerCode(data, this.apiReq.channel);
    // this.getAllOutlet(this.apiReq.region);
  }
  onOutletTypeAll(items: any) {
    this.selectedOutletType = [];
    this.dealercode = [];
    this.selectedDealerCode = [];
    this.apiReq.dealercode = "";
    for (let i = 0; i < items.length; i++) {
      this.selectedOutletType.push(items[i].outlettype);
    }
    let data = "'" + this.selectedOutletType.join("','") + "'";
    this.apiReq.outletType = data;
    this.outletTypeName = data;
    this.getAllDealerCode(data, this.apiReq.channel);

    // this.getAllOutlet(this.apiReq.region);
  }

  onOutletTypeDeSelect(item: any) {
    this.selectedOutletType.splice(
      this.selectedOutletType.indexOf(item.outlettype),
      1
    );
    let data = "'" + this.selectedOutletType.join("','") + "'";
    this.apiReq.outletType = data;
    this.outletTypeName = data;
    this.dealercode = [];
    this.selectedDealerCode = [];
    this.apiReq.dealercode = "";
    this.getAllDealerCode(data, this.apiReq.channel);

    // this.getAllOutlet(this.apiReq.region);
  }

  onOutletTypeDeAll() {
    this.selectedOutletType = [];
    this.dealercode = [];
    this.selectedDealerCode = [];
    this.apiReq.dealercode = "";
    this.apiReq.outletType = "";
    this.outletTypeName = "";
    this.getAllDealerCode("''", this.apiReq.channel);

    // this.getAllOutlet(this.apiReq.region);
  }
  public formatNumber(number: number): string {
    number = Number(number);
    return number.toLocaleString("en-IN");
  }
  public advanceFilter() {
    if (this.firstTimeRun) {
      this.apiReq = {
        dealercode: "",
        leadmedium: "",
        leadtype: "",
        // outlet: "",
        channel: "",
        outletType: "",
      };
    }
    this.getSummaryData();
    this.getQSLSplitData();
    this.getSalesLeadsData();
    this.getDLRMediaData();
    this.getMonthTrendData();
    // this.getLeadRegionCount();
    // this.getLeadOutletCount();
    // this.getLeadZoneCount();
    // this.getTopModelCount();
    // this.getLeadHistory();
    this.firstTimeRun = false;
  }

  public getAllDealerCode(outletType, channelName) {
    this.dataService.startLoader();
    let data = {
      loginInfo: {
        // outlet: this.apiReq.outlet,
      },
      outletType: outletType,
      channel: channelName,
    };
    this.dataService.postMaster("filter/getDealerCodes", data).subscribe(
      (res) => {
        this.dataService.stopLoader();
        if (res["code"] == 200) {
          this.dealercodeList = res["data"];
          let arr = [];
          for (let i = 0; i < this.dealercodeList.length; i++) {
            arr.push(this.dealercodeList[i].dealer);
          }
          let data = "'" + arr.join("','") + "'";
          // check if it has to be implemented this way
          // this.apiReq.dealercode = data;

          // this.getAllRegion(data);
          // this.advanceFilter();
        } else {
          this.dataService.showError(res["message"]);
          if (res["code"] == 401) {
            this.dataService.logout();
          }
        }
      },
      (err) => {
        this.dataService.stopLoader();
        // this.dataService.showError(err['message']);
      }
    );
  }
  public getAllLeadMedium() {
    this.dataService.startLoader();
    this.leadmediumList = leadMedimColums["default"];
    let arr = [];
    for (let i = 0; i < this.leadmediumList.length; i++) {
      arr.push(this.leadmediumList[i].leadmedium);
    }
    let data = "'" + arr.join("','") + "'";
    this.apiReq.leadmedium = data;
    // let data = {
    //   loginInfo: {
    //     // outlet: this.apiReq.outlet,
    //   },
    // };
    // this.dataService.postMaster("filter/getLeadMedium", data).subscribe(
    //   (res) => {
    //     this.dataService.stopLoader();
    //     if (res["code"] == 200) {
    //       this.leadmediumList = res["data"];
    //       let arr = [];
    //       for (let i = 0; i < this.leadmediumList.length; i++) {
    //         arr.push(this.leadmediumList[i].leadmedium);
    //       }
    //       let data = "'" + arr.join("','") + "'";
    //       this.apiReq.leadmedium = data;
    //       // this.getAllRegion(data);
    //     } else {
    //       this.dataService.showError(res["message"]);
    //       if (res["code"] == 401) {
    //         this.dataService.logout();
    //       }
    //     }
    //   },
    //   (err) => {
    //     this.dataService.stopLoader();
    //     // this.dataService.showError(err['message']);
    //   }
    // );
  }
  public getAllLeadType() {
    this.dataService.startLoader();
    let data = {
      loginInfo: {
        // outlet: this.apiReq.outlet,
      },
    };
    this.dataService.postMaster("filter/getLeadType", data).subscribe(
      (res) => {
        this.dataService.stopLoader();
        if (res["code"] == 200) {
          this.leadtypeList = res["data"];
          let arr = [];
          for (let i = 0; i < this.leadtypeList.length; i++) {
            arr.push(this.leadtypeList[i].leadtype);
          }
          // let data = "'" + arr.join("','") + "'";
          // this.apiReq.leadtype = data;          
        } else {
          this.dataService.showError(res["message"]);
          if (res["code"] == 401) {
            this.dataService.logout();
          }
        }
      },
      (err) => {
        this.dataService.stopLoader();
        // this.dataService.showError(err['message']);
      }
    );
  }

  public getAllChannel(regionName) {
    this.dataService.startLoader();
    let data;
    data = {
      loginInfo: {
        // outlet: this.apiReq.outlet,
      },
      // region: regionName,
    };
    this.dataService.postMaster("filter/getDealerChannel", data).subscribe(
      (res) => {
        this.dataService.stopLoader();
        if (res["code"] == 200) {
          this.channelList = res["data"];
          let arr = [];
          for (let i = 0; i < this.channelList.length; i++) {
            arr.push(this.channelList[i].channel);
          }
          let data = "'" + arr.join("','") + "'";
          this.apiReq.channel = data;
          // this.channelName = data;
          this.getAllOutletType(data);
        } else {
          this.dataService.showError(res["message"]);
          if (res["code"] == 401) {
            this.dataService.logout();
          }
        }
      },
      (err) => {
        this.dataService.stopLoader();
        // this.dataService.showError(err['message']);
      }
    );
  }

  public getAllOutletType(channelName) {
    this.dataService.startLoader();
    let data;
    data = {
      loginInfo: {
        // outlet: this.apiReq.outlet,
      },
      channel: channelName,
    };
    this.dataService.postMaster("filter/getOutletType", data).subscribe(
      (res) => {
        this.dataService.stopLoader();
        if (res["code"] == 200) {
          this.outletTypeList = res["data"];
          let arr = [];
          for (let i = 0; i < this.outletTypeList.length; i++) {
            arr.push(this.outletTypeList[i].outlettype);
          }
          let data = "'" + arr.join("','") + "'";
          // this.apiReq.outletType = data;
          this.outletTypeName = data;
          // this.getAllOutlet(regionName);
          this.getAllDealerCode(data, this.apiReq.channel);
        } else {
          this.dataService.showError(res["message"]);
          if (res["code"] == 401) {
            this.dataService.logout();
          }
        }
      },
      (err) => {
        this.dataService.stopLoader();
        // this.dataService.showError(err['message']);
      }
    );
  }

  // public getAllOutlet(parentName) {
  //   this.dataService.startLoader();
  //   let data = {};
  //   if (this.loginData.userType === 2) {
  //     data = {
  //       loginInfo: {
  //         outlet: this.apiReq.outlet,
  //       },
  //       business_unit_id: this.loginData.business_unit_id,
  //       channel: this.channelName,
  //       outletType: this.outletTypeName,
  //       userType: this.loginData.userType,
  //     };
  //   } else {
  //     data = {
  //       loginInfo: {
  //         outlet: this.apiReq.outlet,
  //       },
  //       parent: parentName,
  //       channel: this.channelName,
  //       outletType: this.outletTypeName,
  //       userType: this.loginData.userType,
  //     };
  //   }
  //   this.dataService.postMaster("filter/getOutlet", data).subscribe(
  //     (res) => {
  //       this.dataService.stopLoader();
  //       if (res["code"] == 200) {
  //         this.outletList = res["data"];
  //         let arr = [];
  //         for (let i = 0; i < this.outletList.length; i++) {
  //           arr.push(this.outletList[i].webform_id);
  //         }
  //         let data = "'" + arr.join("','") + "'";
  //         this.apiReq.outlet = data;
  //         this.advanceFilter();
  //       } else {
  //         this.dataService.showError(res["message"]);
  //         if (res["code"] == 401) {
  //           this.dataService.logout();
  //         }
  //       }
  //     },
  //     (err) => {
  //       this.dataService.stopLoader();
  //       // this.dataService.showError(err['message']);
  //     }
  //   );
  // }
  public getSummaryData() {
    this.dataService.startLoader();
    let finalData = {
      dealerCode: this.apiReq.dealercode,
      // outletName: this.apiReq.outlet,
      outletType: this.apiReq.outletType,
      leadMedium: this.apiReq.leadmedium,
      leadType: this.apiReq.leadtype,
      channel: this.channelName,
      start_date: this.filterForm.value.start_date,
      end_date: this.filterForm.value.end_date,
    };
    this.dataService.post("leadReport/summaryLeads", finalData).subscribe(
      (res) => {
        this.dataService.stopLoader();
        if (res["code"] == 200) {
          this.totalLeads = res["data"][0];
        } else {
          this.dataService.showError(res["message"]);
          if (res["code"] == 401) {
            this.dataService.logout();
          }
        }
      },
      (err) => {
        this.dataService.stopLoader();
        // this.dataService.showError(err['message']);
      }
    );
  }

  public getDLRMediaData() {
    this.dataService.startLoader();

    // for DLR media performance only start date,end date
    let finalData = {
      dealerCode: this.apiReq.dealercode,
      // outletName: this.apiReq.outlet,
      outletType: this.apiReq.outletType,
      // leadMedium: this.apiReq.leadmedium,
      leadType: this.apiReq.leadtype,
      channel: this.channelName,
      start_date: this.filterForm.value.start_date,
      end_date: this.filterForm.value.end_date,
    };
    this.dataService
      .post("leadReport/dlrMediaPerformance", finalData)
      .subscribe(
        (res) => {
          this.dataService.stopLoader();
          if (res["code"] == 200) {
            this.dlrMediaData = res["data"];
          } else {
            this.dataService.showError(res["message"]);
            if (res["code"] == 401) {
              this.dataService.logout();
            }
          }
        },
        (err) => {
          this.dataService.stopLoader();
          // this.dataService.showError(err['message']);
        }
      );
  }
  public getQSLSplitData() {
    this.dataService.startLoader();
    let finalData = {
      dealerCode: this.apiReq.dealercode,
      // outletName: this.apiReq.outlet,
      outletType: this.apiReq.outletType,
      leadMedium: this.apiReq.leadmedium,
      leadType: this.apiReq.leadtype,
      channel: this.channelName,
      start_date: this.filterForm.value.start_date,
      end_date: this.filterForm.value.end_date,
    };
    this.dataService.post("leadReport/qslSplitReport", finalData).subscribe(
      (res) => {
        this.dataService.stopLoader();
        if (res["code"] == 200) {
          this.qslData = res["data"];
          // this.qslSplitChart(res["data"]);
        } else {
          this.dataService.showError(res["message"]);
          if (res["code"] == 401) {
            this.dataService.logout();
          }
        }
      },
      (err) => {
        this.dataService.stopLoader();
        // this.dataService.showError(err['message']);
      }
    );
  }

  public totalLeadsChart(info) {
      Highcharts.chart("sales_lead", {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: "pie",
      },
      exporting: { enabled: false },
      title: {
        text: "",
      },
      subtitle: {
        text: "",
      },
      tooltip: {
        formatter: function () {
          return (
            this.point.name +
            ": <b>" +
            this.point.y.toLocaleString("en-IN") +
            "</b><br/>"
          );
        },
      },
      accessibility: {
        point: {
          valueSuffix: "%",
        },
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: "pointer",          
          dataLabels: {
            enabled: true,
            formatter: function (this: any) {
              const value = (this.point.y == 0.00001) ? this.point.y.toLocaleString() : this.point.y;
              return `<span style="font-weight:normal">${this.point.name}:</span> <span style="font-weight:bold">${value}</span>`;
            },
            useHTML: true,
            padding: 0,
            allowOverlap: true,
            crop: false,
            overflow: 'allow', 
            distance: 10,
            connectorPadding: 8,
            style: {
              fontSize: '8px',
              textOutline: 'none'
            },
          },
        },
      },
      series: [
        {
          name: "",
          colorByPoint: true,
          data: info,
        },
      ],
    });
  }
  public monthWiseChart(monthWiseData) {
    Highcharts.chart("monthWiseTrend_chart", {
      chart: {
        type: "column",
      },
      exporting: { enabled: false },
      title: {
        text: "",
      },
      subtitle: {
        text: "",
      },
      accessibility: {
        announceNewData: {
          enabled: true,
        },
      },
      xAxis: {
        type: "category",
      },
      yAxis: [
        {
          title: {
            text: "Total Leads",
          },
        },
        {
          title: {
            text: "QSL %",
          },
          opposite: true,
          max: 100,
        },
      ],
      legend: {
        enabled: false,
      },
      plotOptions: {
        column: {
          borderWidth: 0,
          dataLabels: {
            enabled: true,
            formatter: function () {
              return this.y.toLocaleString("en-IN");
            },
          },
        },
        line: {
          marker: {
            enabled: true,
          },
          dataLabels: {
            enabled: true,
            format: "{point.y}%",
          },
        },
      },
      tooltip: {
        shared: true,
        formatter: function () {
          var points = this.points || [];
          var s = "";
          points.forEach(function (point) {
            if (point.series.name === "Total Leads")
              s +=
                '<br/><span style="color:' +
                point.color +
                '">\u25CF</span> ' +
                point.series.name +
                ": <b>" +
                point.y.toLocaleString("en-IN") +
                "</b>";
            else if (point.series.name === "QSL %")
              s +=
                '<br/><span style="color:' +
                point.color +
                '">\u25CF</span> ' +
                point.series.name +
                ": <b>" +
                point.y +
                "%";
            ("</b>");
          });

          return s;
        },
      },
      series: [
        {
          name: "Total Leads",
          colorByPoint: true,
          data: monthWiseData,
          yAxis: 0,
        },
        {
          type: "line",
          name: "QSL %",
          color: "red",
          data: monthWiseData.map(function (point) {
            return point.z;
          }),
          marker: {
            enabled: true,
          },
          yAxis: 1,
        },
      ],
    });
  }

  public getSalesLeadsData() {
    this.dataService.startLoader();
    let finalData = {
      dealerCode: this.apiReq.dealercode,
      // outletName: this.apiReq.outlet,
      outletType: this.apiReq.outletType,
      leadMedium: this.apiReq.leadmedium,
      leadType: this.apiReq.leadtype,
      channel: this.channelName,
      start_date: this.filterForm.value.start_date,
      end_date: this.filterForm.value.end_date,
      bifurcationBy: this.bifurcationBy
    };
    this.dataService.post("leadReport/callwebLeadReport", finalData).subscribe(
      (res) => {
        this.dataService.stopLoader();
        if (res["code"] == 200) {
          this.totalLeadsChart(res["data"]);
          // this.leadResponseChart(res['data'][0])
        } else {
          this.dataService.showError(res["message"]);
          if (res["code"] == 401) {
            this.dataService.logout();
          }
        }
      },
      (err) => {
        this.dataService.stopLoader();
        this.dataService.showError(err["message"]);
      }
    );
  }

  public getMonthTrendData() {
    this.dataService.startLoader();
    let finalData = {
      dealerCode: this.apiReq.dealercode,
      // outletName: this.apiReq.outlet,
      outletType: this.apiReq.outletType,
      leadMedium: this.apiReq.leadmedium,
      leadType: this.apiReq.leadtype,
      channel: this.channelName,
      start_date: this.filterForm.value.start_date,
      end_date: this.filterForm.value.end_date,
    };
    this.dataService
      .post("leadReport/monthWiseLeadReport", finalData)
      .subscribe(
        (res) => {
          this.dataService.stopLoader();
          if (res["code"] == 200) {
            this.monthWiseChart(res["data"]);
          } else {
            this.dataService.showError(res["message"]);
            if (res["code"] == 401) {
              this.dataService.logout();
            }
          }
        },
        (err) => {
          this.dataService.stopLoader();
          // this.dataService.showError(err['message']);
        }
      );
  }

  public clearFilter() {
    this.dataService.removeCookies("hyperLocalFilter", "");

     this.selectedLeadMedium = [];
  this.selectedDealerCode = [];
  this.selectedLeadType = [];
  this.selectedChannel = [];
  this.selectedOutletType = [];

    window.location.reload();
  }

  onTotalLeadBifurcationChange(event:any) {
    this.bifurcationBy = event.target.value;
    if(this.bifurcationBy) {
      this.getSalesLeadsData();
    }
  }
}
